import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
  Grid,
} from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
  MasterButton,
  ModalHistory,
} from "App/Component/ui";
import { instance4 } from "App/constants";
import { useDatatables } from "App/hooks";
import { formatNumber, isNull } from "App/utils/helpers";
import React, { useState, useEffect, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "./context/FormContext";
import moment from "moment";
import { ModalBarang } from "./ui/ModalBarang";
import { RenderStatusPoBadge } from "../DaftarPo/helpers";
import { trim } from "lodash";

export const urlCreatePO = "/wmsAsset/po/add";
export const urlCreatePOByIdReq = "/wmsAsset/po/add-by-request";
export const urlUpdatePO = "/wmsAsset/po/update";
export const urlGetPoById = "/wmsAsset/po/list_id";

export const urlGetBarangPoById = "/wmsAsset/po/list_id";
export const urlChangeStatus = "/wmsAsset/po/update_transaksi";

export const urlGetGudang = "/wmsMasterAsset/gudang/gudang_central";

export const STATUS_OPEN_DRAFT = false;
export const STATUS_PROCESS = true;

export const STATUS_TRANSAKSI_DRAFT = 0;
export const STATUS_TRANSAKSI_PENGAJUAN = 1;
export const STATUS_TRANSAKSI_DISETUJUI = 2;
export const STATUS_TRANSAKSI_PEMBELIAN = 3;
export const STATUS_TRANSAKSI_SELESAI = 4;

export const FORM_RESET_STATE_WMS_PO = {
  idreq: null,
  idpo: null,
  date: moment(new Date()).local().toDate(),

  unit_id: null,
  unit: "Pilih Unit",

  produsen_id: null,
  produsen: "Pilih Produsen",

  supplier_id: null,
  supplier: "Pilih Supplier",

  penerima: "",
  remark: "",
  nomorPo: "",

  type: "create",
  status: 0,

  isOpenDraf: false,
  isProcess: false,
  isRequest: false,

  jumlah: 0,
  tax: 0,
  total_jumlah: 0,
  listpo: [],
  status_transaksi: 0,
  catatan_proses: "",
  catatan_setuju: "",
};

export const FORM_RESET_BARANG = {
  id: null,
  nama_barang: "",
  nama_barang2: "",
  namasatuan: "Pilih Satuan",
  satuan_id: "",
  qty: 1,
  harga: 0,
  harga2: formatNumber(0),
  disc: 0,
  remark: "",
  onCreate: true,
};

const getMasterGudangOnlyLogistik = async (url) => {
  try {
    const api = await instance4.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const getPoById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetPoById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                totalTax: 0,
                jumlah: 0,
              },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getPoListById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetBarangPoById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        validasi: res.approval_user,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "namabarang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namasatuan",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "disc",
    disablePadding: false,
    label: "DISC (%)",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "sub_jumlah",
    disablePadding: false,
    label: "SUB JUMLAH",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nilai_disc",
    disablePadding: false,
    label: "NILAI DISC",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
];

export const useInitalGudangOnlyLogistik = (
  url = "/wmslogistik/master/gudang/utamaFarmasi/read_po"
) => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getMasterGudangOnlyLogistik(url);
      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, [url]);

  return state;
};

export const setPerhitungan = (formData, setFormData, row) => {
  return setFormData({
    ...formData,
    jumlah: row?.jumlah,
    tax: row?.tax,
    total_jumlah: row?.total_jumlah,
  });
};

export const RenderListPo = ({
  classes,
  listPO,
  formBarang,
  setFormBarang,
  setNewDataPoList,
  setListPO,
}) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const { showModalBarang, setShowModalBarang } = useContext(FormContext);
  const { showModalHistory, setShowModalHistory } = useContext(FormContext);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listPO,
    orderByDefault: "nama_barang",
    orderByRow: ["nama_barang"],
  });
  const { formData } = useContext(FormContext);

  async function deleteList() {
    const barang = listPO;
    let checkBarang = [];
    if(isNull(formBarang.barang_id)){
      checkBarang = barang.filter(
        (e) => e.nama_barang !== formBarang.nama_barang
      );
    }else{
      checkBarang = barang.filter(
        (e) => e.barang_id !== formBarang.barang_id
      );
    }
    setListPO(checkBarang);
    setShowModalDeleteConfirm(false);
  }

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormBarang({
      ...formBarang,
      barang_id: row?.barang_id,
      nama_barang: trim(row?.nama_barang),
    });
  };

  const handleClickUpdate = async (row) => {
    await setFormBarang({
      id: row?.id,
      satuan_id: row?.satuan_id,
      nama_barang: trim(row?.nama_barang),
      nama_barang2: trim(row?.nama_barang),
      namasatuan: row?.namasatuan,
      qty: row?.qty,
      disc: row?.disc,
      harga: row?.harga,
      harga2: formatNumber(row?.harga),
      is_create: false,
    });
    setShowModalBarang(!showModalBarang);
  };

  const handleClickTambah = () => {
    setShowModalBarang(!showModalBarang);
    setFormBarang(FORM_RESET_BARANG);
  };

  const handleClickHistory = () => {
    setShowModalHistory(!showModalHistory);
  };

  return (
    <>
      {showModalBarang && (
        <ModalBarang
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewDataPoList={setNewDataPoList}
          setListPO={setListPO}
          listPO={listPO}
        />
      )}
      {showModalHistory && (
        <ModalHistory
          title={"History Purchase Order"}
          id={formData?.idpo}
          showModal={setShowModalHistory}
          url={"/wmsAsset/po/histori"}
        />
      )}
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
        }}>
        {formData.idpo !== "" && (
          <>
            <p className='fw-600 mr-1'>Status : </p>
            <RenderStatusPoBadge status={formData.status_transaksi} />
          </>
        )}
      </div>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        className='mb-1'>
        <h5 className='fw-600'>Data Transaksi PO</h5>
        <div
          style={{
            display: "flex",
            gap: "10px",
          }}>
          {" "}
          <MasterButton
            onClick={isNull(formData.idpo) ? null : handleClickHistory}
            disabled={isNull(formData.idreq) ? true : false}
            className={"mt-1"}
            type={"button"}
            color={(!isNull(formData.idpo) && isNull(formData.idreq)) || isNull(formData.idpo) ? "secondary" : "lightgreen"}
            name='History Request'
            size='md'
          />
          <MasterButton
            onClick={
              formData.status_transaksi === STATUS_TRANSAKSI_DRAFT &&
              !formData.isRequest
                ? handleClickTambah
                : null
            }
            disabled={false}
            className={"mt-1"}
            type={"button"}
            color={
              formData.status_transaksi === STATUS_TRANSAKSI_DRAFT &&
              !formData.isRequest
                ? "green"
                : "secondary"
            }
            name='Tambah Barang'
            size='md'
          />
        </div>
      </Grid>
      <TableContainer className='custom-scrollbar'>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {!formData.isProcess &&
                      formData.status_transaksi === STATUS_TRANSAKSI_DRAFT ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}>
                          <IconButtonDatatable
                            onClick={() => handleClickUpdate(row)}>
                            <PencilIcon />
                          </IconButtonDatatable>

                          {!formData.isRequest && (
                            <IconButtonDatatable
                              onClick={() => handleClickDelete(row)}>
                              <TrashIcon />
                            </IconButtonDatatable>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <RenderTableCell row={row} />
                  </TableRow>
                );
              })}
            {listPO.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20, 50, 100]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
      {/* <h6>*Harap lakukan UPDATE setelah melakukan perubahan</h6> */}
    </>
  );
};

const RenderTableCell = ({ row }) => {
  const harga_x_qty = row.harga * row.qty;
  const nilaiDisc = (row.disc / 100) * harga_x_qty;
  const jumlah = harga_x_qty - nilaiDisc;
  return (
    <>
      <TableCell align='left'>{row?.id}</TableCell>
      <TableCell align='left'>{row?.nama_barang}</TableCell>
      <TableCell align='left'>{row?.namasatuan}</TableCell>
      <TableCell align='left'>{row.qty}</TableCell>
      <TableCell align='left'>{formatNumber(row.harga)}</TableCell>
      <TableCell align='left'>{row.disc}</TableCell>
      <TableCell align='left'>{formatNumber(harga_x_qty)}</TableCell>
      <TableCell align='left'>{formatNumber(nilaiDisc)}</TableCell>
      <TableCell align='left'>{formatNumber(jumlah)}</TableCell>
    </>
  );
};
